import { render, staticRenderFns } from "./c-partner.vue?vue&type=template&id=a7637a48&"
import script from "./c-partner.vue?vue&type=script&lang=js&"
export * from "./c-partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports